module.exports = __webpack_public_path__ + "static/primary-97955dd5480752c9501c3a1fc6f8cf0c.png";